import { Workspace } from './Workspace';
import { User } from './User';

export enum APIKeyTimeLength {
    ONE_WEEK = '1 Week',
    THIRTY_DAYS = '30 Days',
    THREE_MONTHS = '3 Months',
    ONE_YEAR = '1 Year',
    NEVER_EXPIRES = 'Never Expires',
}

export enum APIKeyIntegration {
    ZAPIER = 'Zapier',
    MAKE = 'Make',
    NO_INTEGRATION = 'N/A',
}


export interface APIKey {
  id: string;
  key: string;
  workspace: Workspace;
  user: User;
  name: string;
  resources: string[] | undefined;
  timeLength: APIKeyTimeLength | undefined;
  integration: APIKeyIntegration | undefined;
  createdAt: Date;
  updatedAt: Date;
}
